import React from 'react'
import { Col, Nav, Row } from 'react-bootstrap'
import { Icon } from '@iconify/react';
import HeadingOne from '../baseui/HeadingOne';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
  setClientIsActive,
} from "../../redux/surveySlice";

const TopBar = () => {
  
  const dispatch = useDispatch()
  const activeMenu = ()=> {
    console.log('ppp')
    dispatch(setClientIsActive(true))
  }
  return (
    <div className="topbar">
    <Row className='align-items-center'>
    <Col lg="6">
     <HeadingOne heading1="Survey"/>
    </Col>
    <Col lg="6">
          <div className="text-end d-block d-xxl-none">
            <Link to="#" className='cta-link' onClick={activeMenu}>View Clients</Link>
          </div>
     </Col>
    </Row>
</div>
  )
}

export default TopBar